export function convertToKilo(value: number | null): number | null {
  if (value === null) return null
  return value / 1000
}
